import getItemStyles from '../../../utils/item-styles.js';
import timelineDisplayOrder from './timelineDisplayOrder.js';

/**
 * Generates overtime objects that are put on the same level as the tour object. The object location and id are based upon where
 * the meal item falls within the greater display object.
 * @param {*} mealPosition
 * @param {*} resource
 * @param {*} dayType
 * @param {*} mealStartTime
 * @param {*} mealEndTime
 */
const generateOvertime = (mealPosition, resource, dayType,
  mealStartTime, mealEndTime, overtimeStartTime, overtimeEndTime) => {
  const { rId } = resource;
  const { rdtId } = dayType;
  const { tourId } = dayType.tour;
  const overtimeStyle = getItemStyles('overtime');
  let adjustedOvertime;
  const overtime = {
    id: tourId + '-ot',
    rdtId,
    itemType: 'overtime',
    group: rId,
    start_time: overtimeStartTime,
    end_time: overtimeEndTime,
    backgroundColor: dayType.tour.isApproved ? 'gray' : overtimeStyle.backgroundColor,
    borderStyle: overtimeStyle.borderStyle,
    borderColor: overtimeStyle.borderColor,
    timelineDisplayOrder: timelineDisplayOrder.tour
  };

  if (mealPosition === 'no-meal') {
    return overtime;
  } else if (mealPosition === 'meal-first') {
    adjustedOvertime = {
      ...overtime,
      start_time: mealEndTime
    }
    return adjustedOvertime;
  } else if (mealPosition === 'meal-middle') {
    adjustedOvertime = {};
    adjustedOvertime.preMeal = {
      ...overtime,
      id: tourId + '-ot-preMeal',
      end_time: mealStartTime
    };
    adjustedOvertime.postMeal = {
      ...overtime,
      id: tourId + '-ot-postMeal',
      start_time: mealEndTime
    };
    return adjustedOvertime;
  }
}

export default generateOvertime;
